import "./LoadingBig.css";

export default function LoadingBig({show = false}) {
    return (
        <span className={'loader-kfrg2'+(!show ? ' d-none' : '')}></span>
    );
}